<template>
  <div :class="['list_box','list-box-style-'+listArr.module_style]" ref="rowEL">
    <div class="circle-wrap"
         :style="{...outerCircleStyle}">
      <div class="circle-inner-wrap"
           :style="{...innerCircleStyle}">
        <div class="info-wrapper">
          <div class="center-icon-wrapper">
            <img class="info-icon" :src="currentCenterInfo.img_path" :alt="currentCenterInfo.title"/>
          </div>
          <div class="circle-title" :style="{...titleFontStyle}">{{ currentCenterInfo.title }}</div>
          <div v-if="pc_infor.alt_display=='true'" class="circle-summary" :style="{...summaryFontStyle}"
               :title="currentCenterInfo.summary">
            {{ currentCenterInfo.summary }}
          </div>
        </div>
      </div>
      <template v-for="(item,i) in imgs">
        <div class="icon-wrapper icon-wrapper-circle"
            :key="i"
             @mouseenter="onMouseEnterIcon(i)"
             @mouseleave="onMouseLeaveIcon(i)">
          <img class="img-icon" :src="item.img_path" :alt="item.title"
               :style="{width:infor.img_size[infor.img_size.radio_val].widthPercent+'%'}">
          <set_link class="linkPart" :sendData="item.intro"></set_link>
          <div
            class="tooptipPart one-icon-tooptip"
            v-if="$store.state.app.view_pattern === 'pc' && item.img_type == 'custom'"
            @click.stop
          >
            <my_edit_btn :module="module" tabName="style" coverClick @click.native="onClickEditBtn"></my_edit_btn>
            <my_hover_btn :tips="$t('widgets_basic_icon_combination_components_circle_layout_588')" btnIcon="el-icon-close" @changeStyle="del_one"></my_hover_btn>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

import {debounce} from "throttle-debounce";
import Store from "../../../vuex/store";

export default {
  name: "CircleLayout",
  data() {
    return {
      currentIndex: 0,
      circleLayoutPositionList: [],
      interval: null,
      isAniActive: true,
      currentCenterInfo: this.imgs[0] || {},
      moduleWidth: 500
    }
  },
  props: {
    imgs: {
      type: Array
    },
    module: {
      type: Object,
      default: null
    },
  },
  computed: {
    isPC() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    isMobile() {
      return this.$store.state.app.view_pattern === 'mb'
    },
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + "_widgets_infor"];
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor;
    },
    listArr() {
      return this.module.data.listArr
    },
    currentObj() {
      return this.imgs[this.currentIndex]
    },
    titleFontStyle() {
      return this.$utils.getFontStyle(this.pc_infor.titleFont, this)
    },
    summaryFontStyle() {
      return this.$utils.getFontStyle(this.pc_infor.summaryFont, this)
    },
    backgroundStyle() {
      return this.$utils.getBackgroundStyle(this.pc_infor, {
        defaultBackgroundColor: "#eee"
      })
    },
    outerCircleStyle() {
      let infor = this.pc_infor
      return {
        borderColor: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.color : '#eee'
      }
    },
    innerCircleStyle() {
      return this.$utils.getBackgroundStyle(this.pc_infor)
    },
    iconBackground() {
      let infor = this.pc_infor
      return {
        backgroundColor: infor.icon_background.radio_val == 'custom' ? infor.icon_background.custom.color : infor.icon_background.default.color,
        backgroundImage: infor.icon_background.radio_val == 'custom' && infor.icon_background.custom.img !== '' ? 'url(' + infor.icon_background.custom.img + ')' : '',
        backgroundSize: infor.icon_background.radio_val == 'custom' ? infor.icon_background.custom.background_size : '',
        backgroundRepeat: infor.icon_background.radio_val == 'custom' ? infor.icon_background.custom.background_repeat : '',
        backgroundPosition: infor.icon_background.radio_val == 'custom' ? infor.icon_background.custom.background_position : ''
      }
    },
    isCurrentEditModule() {
      return this.$store.state.app.module_Data === this.module
    },
    isEditing() {
      return this.isCurrentEditModule && this.$store.state.main_dialog.main_dialog_isShow
    },
    isInCurrentModule() {
      let moduleData = this.$store.state.app.module_Data
      const cols = moduleData.children || [];
      for (let j = 0; j < cols.length; j++) {
        const modules = cols[j].children;
        for (let k = 0; k < modules.length; k++) {
          if (modules[k].widgets_id == this.module.widgets_id) {
            return true
          }
        }
      }
      return false
    }
  },
  watch: {
    'module.data.listArr': {
      handler: function (val, oldVal) {
        this.debounceGetCircleLayoutStyle()
      },
      deep: true
    },
    '$store.state.app.module_Data': {
      handler(val, oldVal) {
        if (!val || !oldVal) {
          return
        }
        if (this.isInCurrentModule) {
          this.debounceGetCircleLayoutStyle()
        }
      },
      deep: true
    },
    '$store.state.module.drag_val.right'() {
      this.debounceGetCircleLayoutStyle()
    },
    '$store.state.app.view_pattern'() {
      this.debounceGetCircleLayoutStyle()
    },
    '$store.state.app.editPhotoListSelectId'(val) {
      let currentIndex = this.imgs.findIndex(item => item.album_id === val)
      if (currentIndex >= 0) {
        this.stopLoopPlay()
        this.currentIndex = currentIndex
        $(this.$refs.rowEL).find('.icon-wrapper-circle').eq(this.currentIndex).addClass('icon-circle-pop')
      }
    },
    currentIndex() {
      // 如果用vue的transition组件，切换v-if，浏览器标签页切换到后台一段时间 再切换回来 会有很多个动画堆积在一起
      $(this.$refs.rowEL).find('.info-wrapper').fadeOut('slow', () => {
        setTimeout(() => {
          this.currentCenterInfo = this.imgs[this.currentIndex]
          $(this.$refs.rowEL).find('.info-wrapper').fadeIn('slow')
        }, 100)
      })
    },
    iconBackground() {
      $(this.$imgs).css({
        ...this.iconBackground
      })
    },
    isEditing(val) {
      if (!val) {
        this.loopPlay()
      }
    },
  },
  methods: {
    onClickEditBtn() {
      this.$store.commit("app/changeModuleSelectItemId", this.currentObj.album_id);
      this.templet.changeStyle(this.module, 'style');
    },
    del_one() {
      if (this.imgs.length <= 1) {
        this.$message.error({
          showClose: true,
          message: i18n.t('widgets_basic_icon_combination_components_circle_layout_589')
        });
        return;
      }
      this.$confirm(i18n.t('widgets_basic_icon_combination_components_circle_layout_590'), "", {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        center: true,
        // customClass: "del_dialog",
        appendToBody: true
      })
        .then(() => {
          this.imgs.splice(this.i, 1);
        })
        .catch(() => {
        });
    },
    debounceGetCircleLayoutStyle() {

    },
    setCircleLayoutStyle() {
      this.$imgs = this.$wrapper.find('.icon-wrapper-circle')
      this.$imgs = $.makeArray(this.$imgs)
      let $module = $(this.$refs.rowEL).parents('.module')
      let moduleWidth = $module.width()
      moduleWidth = Math.max(moduleWidth, 250)
      moduleWidth = Math.min(moduleWidth, 600)
      $(this.$refs.rowEL).css({
        width: moduleWidth,
        height: moduleWidth
      })
      this.getCircleLayoutStyle()
      this.circleLayoutPositionList.forEach((style, index) => {
        // $(this.imgs[index]).css({...style, visibility: 'visible'})
        let css = {
          visibility: 'visible',
          position: 'absolute',
          ...this.iconBackground
        }
        if (!this.isInited) {
          css = Object.assign(css, {
            top: '46%',
            left: '46%'
          })
        }
        $(this.$imgs[index]).css(css)
        setTimeout(() => {
          $(this.$imgs[index]).animate(style)
        }, index * 150)
      })
      this.isInited = true
    },
    getCircleLayoutStyle() {
      if (this.isCircleLayout()) {
        this.circleLayoutPositionList = []
        this.imgs.forEach((item, index) => {
          this.circleLayoutPositionList.push(this.getCircleLayoutPosition(index))
        })
      } else {
        $(this.$refs.rowEL).css({
          height: 'auto',
          width: 'auto',
          display: 'flex',
        })
        this.circleLayoutPositionList = [{}, {}, {}, {}]
        $(this.$refs.rowEL).find('.list_one').css('position', 'relative');
        $(this.$refs.rowEL).find('.list_one').css('top', '0');
        $(this.$refs.rowEL).find('.list_one').css('left', '0');
      }
    },
    getCircleLayoutPosition(index) {
      if (!this.isCircleLayout()) {
        return {}
      }
      let $item = $(this.$refs.rowEL).find('.icon-wrapper-circle').first()
      let itemWidth = $item.width()
      let itemHeight = $item.height()
      let degree = (index / this.imgs.length) * 360 - 90
      let outerRadius = $(this.$refs.rowEL).find('.circle-wrap').width() / 2
      let radius = ($(this.$refs.rowEL).find('.circle-wrap').width()) / 2
      let centerX = radius
      let centerY = radius

      let option = {
        degree,
        radius,
        centerX,
        centerY
      }
      let style = {}
      let position = this.getPositionByDegree(option)
      style.top = position.y
      style.left = position.x

      style.left = style.left - itemWidth / 2
      style.top = style.top - itemHeight / 2


      style.top = style.top + 'px'
      style.left = style.left + 'px'

      style.position = 'absolute'
      style.marginTop = '0'
      return style
    },
    getPositionByDegree({degree, radius, centerX, centerY}) {
      return {
        x: Math.round(centerX + radius * Math.cos(degree * Math.PI / 180)),
        y: Math.round(centerY + radius * Math.sin(degree * Math.PI / 180)),
      }
    },
    isCircleLayout() {
      return Number(this.listArr.module_style) === 3
    },
    loopPlay() {
      $(this.$refs.rowEL).find('.icon-wrapper-circle').eq(this.currentIndex).addClass('icon-circle-pop')
      this.interval = setInterval(() => {
        this.currentIndex = this.currentIndex >= this.imgs.length - 1 ? 0 : this.currentIndex + 1
        $(this.$refs.rowEL).find('.icon-circle-pop').removeClass('icon-circle-pop')
        $(this.$refs.rowEL).find('.icon-wrapper-circle').eq(this.currentIndex).addClass('icon-circle-pop')

      }, 3000)
    },
    stopLoopPlay() {
      this.isAniActive = false
      clearInterval(this.interval)
      $(this.$refs.rowEL).find('.icon-circle-pop').removeClass('icon-circle-pop')
    },
    onMouseEnterIcon(index) {
      this.stopLoopPlay()
      this.currentIndex = index
      $(this.$refs.rowEL).find('.icon-wrapper-circle').eq(this.currentIndex).addClass('icon-circle-pop')
    },
    onMouseLeaveIcon() {
      if (this.isEditing) {
        return
      }
      this.loopPlay()
    },
    bind() {
      window.addEventListener('resize', this.debounceGetCircleLayoutStyle)
      document.addEventListener('visibilitychange', this.debounceGetCircleLayoutStyle)
    },
    unbind() {
      window.removeEventListener('resize', this.debounceGetCircleLayoutStyle)
      document.removeEventListener('visibilitychange', this.debounceGetCircleLayoutStyle)
    },
    setMargin() {
      let info = this.module.data.pc_infor
      if (!info.marginLeft || !info.marginRight || info.marginLeft === '0%' || info.marginRight === '0%') {
        info.marginLeft = '30%'
        info.marginRight = '30%'
      }
    }
  },
  created() {
    this.setMargin()
    this.debounceGetCircleLayoutStyle = debounce(500, false, this.setCircleLayoutStyle.bind(this))
  },
  mounted() {
    this.$wrapper = $(this.$refs.rowEL)
    this.$imgs = this.$wrapper.find('.icon-wrapper-circle')
    this.$imgs = $.makeArray(this.$imgs)
    this.debounceGetCircleLayoutStyle()
    this.loopPlay()
    this.bind()
  },
  beforeDestroy() {
    this.unbind()
  }
}
</script>

<style scoped lang="scss">
.mb_pattern .list-box-style-3 {
  width: 350px;
  height: 350px;
}

.mb_pattern .icon-wrapper-circle.icon-wrapper {
  width: 40px;
  height: 40px;
  line-height: 40px;
}

.icon-wrapper-circle {
  visibility: hidden;
}

.list-box-style-3 {
  width: 500px;
  height: 500px;
  display: block !important;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5%;


  @media screen and(min-width: 1600px) {
    width: 700px;
    height: 700px;
  }

  @media screen and(min-width: 1200px) {
    width: 600px;
    height: 600px;
  }


  @media screen and(max-width: 500px) {
    width: 450px;
    height: 450px;
    .icon-wrapper-circle.icon-wrapper {
      width: 40px;
      height: 40px;
      line-height: 40px;
    }
  }

  @media screen and(max-width: 450px) {
    width: 400px;
    height: 400px;
  }

  @media screen and(max-width: 400px) {
    width: 350px;
    height: 350px;
  }

  @media screen and(max-width: 350px) {
    width: 300px;
    height: 300px;
  }

  @media screen and(max-width: 300px) {
    width: 250px;
    height: 250px;

    .icon-wrapper-circle.icon-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
    }
  }

}

.circle-wrap {
  width: 90%;
  height: 90%;
  margin-top: 5%;
  margin-bottom: 5%;
  margin-left: auto;
  margin-right: auto;
  border: 5px solid #eee;
  border-radius: 50%;
  position: relative;
}


.circle-inner-wrap {
  display: table;
  width: 80%;
  margin: 10%;
  padding: 20px;
  height: 80%;
  border-radius: 50%;
  background: #eee;
}

.info-wrapper {
  width: 100%;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.center-icon-wrapper {
  display: inline-block;
  width: 40px;
  height: 40px;
}

.circle-title {
  margin-top: 5px;
}

.circle-summary {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding-left: 6%;
  padding-right: 6%;
}

.icon-wrapper-circle {
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: rgb(255, 181, 54);
  vertical-align: middle;
  border-radius: 50%;
  cursor: pointer;
}

.img-icon {
  vertical-align: middle;
  width: 60%;
  height: auto;
  max-width: 100%;
}

.icon-circle-pop {
  -webkit-animation-name: circle-pop;
  animation-name: circle-pop;
  -webkit-animation-duration: 1.5s;
  animation-duration: 1.5s;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}


@keyframes circle-pop {
  50% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/widgets/basic_icon_combination/components/circle_layout.vue